class MnProductGallery extends HTMLElement {
  connectedCallback() {
    this._mediaQuery = window.matchMedia('(min-width: 768px)');
    this._onMediaChange = () => this._syncObservers();
    this._mediaQuery.addEventListener('change', this._onMediaChange);

    this._onGalleryImageChange = (event) => {
      this._scrollToImage(event.detail && event.detail.imageId);
    };
    document.addEventListener('mn:gallery-image-change', this._onGalleryImageChange);

    this._syncObservers();
  }

  disconnectedCallback() {
    this._mediaQuery.removeEventListener('change', this._onMediaChange);
    document.removeEventListener('mn:gallery-image-change', this._onGalleryImageChange);
    this._teardownObservers();
  }

  _syncObservers() {
    if (this._mediaQuery.matches) {
      this._setupObservers();
    } else {
      this._teardownObservers();
    }
  }

  _setupObservers() {
    if (this._intersectionObserver) {
      return;
    }

    const gallery = this.querySelector('.my-gallery');
    if (!gallery) {
      return;
    }

    // the figure matching the currently selected variant is only marked via the (now
    // CSS-overridden) "hide" class — scroll to it once so the gallery doesn't always
    // open on image #1 regardless of which variant/color was selected on load
    const activeFigure = gallery.querySelector('[data-mn-index]:not(.hide)') || gallery.querySelector('[data-mn-index]');
    if (activeFigure) {
      activeFigure.scrollIntoView({ behavior: 'auto', block: 'start' });
      this._onActiveFigureChange(activeFigure);
    }

    this._intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          this._onActiveFigureChange(entry.target);
        }
      });
    }, {
      root: gallery,
      threshold: 0.5,
    });

    gallery.querySelectorAll('[data-mn-index]').forEach((figure) => {
      this._intersectionObserver.observe(figure);
    });
  }

  _teardownObservers() {
    if (this._intersectionObserver) {
      this._intersectionObserver.disconnect();
      this._intersectionObserver = null;
    }
  }

  _onActiveFigureChange(figure) {
    const counter = this.querySelector('.mn-product-gallery__counter-current');
    if (counter) {
      counter.textContent = figure.getAttribute('data-mn-index');
    }

    // keep the (still-visible) thumbnail rail in sync with scroll-driven navigation,
    // since both are now valid ways to move through the gallery
    const imageId = figure.getAttribute('data-image-id');
    if (!imageId) {
      return;
    }
    document.querySelectorAll('.product-single__thumbnail-item.is-active').forEach((thumb) => {
      thumb.classList.remove('is-active');
    });
    const activeThumb = document.querySelector(`.product-single__thumbnail-item[data-image-id="${imageId}"]`);
    if (activeThumb) {
      activeThumb.classList.add('is-active');
    }
  }

  _scrollToImage(imageId) {
    if (!imageId || !this._mediaQuery.matches) {
      return;
    }
    const figure = this.querySelector(`[data-image-id="${imageId}"]`);
    if (figure) {
      figure.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}

customElements.define('mn-product-gallery', MnProductGallery);
